import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  ModalClose,
  ModalDialog,
  Typography,
} from "@mui/joy";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { useRoutesUiStore } from "@/components/RoutesProvider";

import { useModal } from "./useModal";

export default function UnsavedChanges({ uuid }: { uuid?: string }) {
  const { close } = useModal();
  const {
    routeFormIsDirty,
    createRouteData,
    setDisplayRouteSidebar,
    setRouteFormIsDirty,
    setCreateRouteData,
    clearMapPositionEdit,
    clearRouteFormEdit,
  } = useRoutesUiStore(
    useShallow((state) => ({
      routeFormIsDirty: state.routeFormIsDirty,
      createRouteData: state.createRouteData,
      setDisplayRouteSidebar: state.setDisplayRouteSidebar,
      setRouteFormIsDirty: state.setRouteFormIsDirty,
      setCreateRouteData: state.setCreateRouteData,
      clearMapPositionEdit: state.clearMapPositionEdit,
      clearRouteFormEdit: state.clearRouteFormEdit,
    })),
  );

  useEffect(() => {
    if (!createRouteData && !routeFormIsDirty) {
      close();
    }
  }, [createRouteData, routeFormIsDirty, close]);

  const discard = () => {
    close();
    setRouteFormIsDirty(false);
    setDisplayRouteSidebar(false);
    createRouteData && setCreateRouteData(undefined);
    if (createRouteData || uuid) {
      clearMapPositionEdit(createRouteData ? "CREATING" : uuid!);
      clearRouteFormEdit(createRouteData ? "CREATING" : uuid!);
    }
  };

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>Cancel route edits?</DialogTitle>
      <DialogContent>
        <Typography sx={{ maxWidth: 350 }}>
          You have unsaved changes. Are you sure you want to leave?
        </Typography>
      </DialogContent>
      <form>
        <DialogActions>
          <Button color="danger" onClick={discard} sx={{ flex: 1 }}>
            Discard
          </Button>
          <Button color="neutral" variant="soft" onClick={close} sx={{ flex: 1 }}>
            Cancel
          </Button>
        </DialogActions>
      </form>
    </ModalDialog>
  );
}
